module.exports = require("core-js/library/fn/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/map.js
// module id = 1365
// module chunks = 0